import React, { Component } from "react";
import { Link } from "react-router-dom";
import Checkbox from "material-ui/Checkbox";
import IconButton from "material-ui/IconButton";
import Ripple from "material-ui/internal/TouchRipple";
import Close from "material-ui/svg-icons/navigation/close";
import Search from "material-ui/svg-icons/action/search";
import AddIcon from "material-ui/svg-icons/content/add";
import ChevronLeft from "material-ui/svg-icons/navigation/chevron-left";
import ChevronRight from "material-ui/svg-icons/navigation/chevron-right";
import ArrowUpward from "material-ui/svg-icons/navigation/arrow-upward";
import FileDownload from "material-ui/svg-icons/file/file-download";

import "./List.css";

export default class List extends Component {
  sort = (column, unsortable) => () => {
    if (unsortable === undefined || unsortable === false) {
      this.props.sort(column);
    }
  };

  warningExport = () => () => {
    this.props.warningExport();
  };

  changePage = page => () => {
    this.props.changePage(page);
  };

  select = selected => () => {
    if (this.props.twoStepsSelectable) {
      this.props.select(selected);
    }
  };

  toggleFiltering = () => {
    this.props.toggleFiltering();
  };

  renderSortArrow(target) {
    const { sortColumn, sortDescending } = this.props.list;
    if (target === sortColumn) {
      const rotate = sortDescending
        ? { transform: "rotateZ(0)" }
        : { transform: "rotateZ(-180deg)" };
      return (
        <ArrowUpward
          style={{
            position: "absolute",
            marginLeft: "-18px",
            top: "19px",
            width: "16px",
            height: "16px",
            ...rotate
          }}
        />
      );
    }
  }

  renderTwoStepsSelectorHeader() {
    if (this.props.twoStepsSelectable) {
      return <th className="selector" />;
    }
  }

  renderDirectSelectorHeader() {
    if (this.props.directlySelectable) {
      return <th className="selector" />;
    }
  }

  renderHeader() {
    return (
      <tr>
        {this.renderTwoStepsSelectorHeader()}
        {this.props.model.map((column, i) => {
          const classes =
            this.props.list.sortColumn === column.target
              ? `col${i} sorted`
              : `col${i}`;
          return (
            <th
              key={i}
              className={classes}
              onClick={this.sort(column.target, column.unsortable)}
            >
              {column.unsortable === undefined ||
              column.unsortable === false ? (
                <Ripple>
                  {this.renderSortArrow(column.target)}
                  {column.label}
                </Ripple>
              ) : (
                column.label
              )}
            </th>
          );
        })}
        {this.renderDirectSelectorHeader()}
      </tr>
    );
  }

  renderTwoStepsSelectorColumn(selected) {
    if (this.props.twoStepsSelectable) {
      return (
        <td className="selector">
          <Checkbox checked={selected} />
        </td>
      );
    }
  }

  renderDirectAddColumn(dataId) {
    const { addSelected, addCallback } = this.props;
    if (addSelected && addCallback && typeof addCallback === "function") {
      return (
        <td className="direct-selector" onClick={addCallback(dataId)}>
          <IconButton
            className="direct-selector-btn"
            style={{
              backgroundColor: "#d50000",
              borderRadius: "40px",
              width: "24px",
              height: "24px",
              padding: "3px"
            }}
            iconStyle={{ width: "18px", height: "18px", fill: "white" }}
          >
            <AddIcon />
          </IconButton>
        </td>
      );
    }
  }

  renderDirectSelectColumn(url) {
    if (this.props.directlySelectable) {
      return (
        <td className="direct-selector">
          <Link to={url}>
            <IconButton
              className="direct-selector-btn"
              style={{
                backgroundColor: "#d50000",
                borderRadius: "40px",
                width: "24px",
                height: "24px",
                padding: "3px"
              }}
              iconStyle={{ width: "18px", height: "18px", fill: "white" }}
            >
              <ChevronRight />
            </IconButton>
          </Link>
        </td>
      );
    }
  }

  renderBody() {
    const { list, model, rows, rowExtractor } = this.props;
    return rows.length > 0 ? (
      rows.map(row => {
        const data = rowExtractor ? rowExtractor(row) : row;
        const selected = list.selected === data.id;
        const classes = selected ? "selected" : undefined;
        const { selectRowUrl } = row;
        return (
          <tr key={data.id} className={classes} onClick={this.select(data.id)}>
            {this.renderTwoStepsSelectorColumn(selected)}
            {model.map((column, i) => (
              <td key={`${data.id}-${i}`} className={`col${i}`}>
                <span>{data[column.target]}</span>
              </td>
            ))}
            {this.renderDirectSelectColumn(selectRowUrl)}
            {this.renderDirectAddColumn(data.id)}
          </tr>
        );
      })
    ) : (
      <tr className="no-results">
        <td colSpan={model.length}>
          <div>
            <div className="no-results-text">
              Aucun résultat ne correspond à votre recherche
            </div>
            <div className="no-results-subtext">
              Veuillez modifier vos critères de sélection et recommencer
            </div>
          </div>
        </td>
      </tr>
    );
  }

  renderPrevButton() {
    const { page } = this.props.list;
    const disabled = page <= 1;
    return (
      <IconButton disabled={disabled} onClick={this.changePage(page - 1)}>
        <ChevronLeft />
      </IconButton>
    );
  }

  renderNextButton() {
    const { page, pageCount } = this.props.list;
    const disabled = page >= pageCount;
    return (
      <IconButton disabled={disabled} onClick={this.changePage(page + 1)}>
        <ChevronRight />
      </IconButton>
    );
  }

  renderExport() {
    const props =
      this.props.exportTooBig === true && this.props.warningExport !== undefined
        ? { onClick: this.warningExport() }
        : { href: this.props.exportUrl, download: "Export.xlsx" };
    return this.props.exportUrl ? (
      <th className="export">
        <IconButton {...props}>
          <FileDownload />
        </IconButton>
      </th>
    ) : null;
  }

  renderPagination() {
    const { page, pageCount } = this.props.list;
    return this.props.changePage && this.props.rows.length > 0 ? (
      <th>
        {this.renderPrevButton()}
        {this.renderNextButton()}
        <span className="footer-large-width">
          Page {page} sur {pageCount}
        </span>
        <span className="footer-small-width">
          {page} / {pageCount}
        </span>
      </th>
    ) : this.props.exportUrl ? (
      <th />
    ) : null;
  }

  renderCountAndSum() {
    const reducedSeparator =
      this.props.count !== undefined && this.props.sum !== undefined
        ? " / "
        : "";
    return this.props.count !== undefined || this.props.sum !== undefined ? (
      <th className="count-sum-footer">
        <span className="footer-large-width">
          {this.props.countSumPrefix}
          {this.props.count}
          {this.props.countSumMid}
          {this.props.sum}
          {this.props.countSumSuffix}
        </span>
        <span className="footer-small-width">
          {this.props.count}
          {reducedSeparator}
          {this.props.sum}
        </span>
      </th>
    ) : null;
  }

  renderFooter() {
    return (this.props.rows.length > 0 && this.props.changePage) ||
      (this.props.rows.length > 0 && this.props.exportUrl) ||
      (this.props.count !== undefined || this.props.sum !== undefined) ? (
      <tr>
        {this.renderExport()}
        {this.renderPagination()}
        {this.renderCountAndSum()}
      </tr>
    ) : null;
  }

  render() {
    const { title, list } = this.props;
    const icon = list.filtering ? <Close /> : <Search />;
    const classes = "list card" + (list.filtering ? " filtering" : "");
    return (
      <div className={classes}>
        <div className="title--container">
          <div className="title">
            <span>{title}</span>
            {this.props.filters ? (
              <IconButton onClick={this.toggleFiltering}>{icon}</IconButton>
            ) : null}
          </div>
          {this.props.filters}
        </div>
        <table>
          <thead>{this.renderHeader()}</thead>
          <tbody>{this.renderBody()}</tbody>
          <tfoot>{this.renderFooter()}</tfoot>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/List.js